import { useFormContext } from 'react-hook-form';
import { useSendingPlatformsQueryContext } from '../../../../contexts';
import { useUpdateAccount } from '../../../../hooks';
import { MAILGUN } from '../../../../constants';
import { getEspRadioOptionsForSendingPlatform } from '../../../../utils';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../../../types';
import { AccountTypesRadioListField } from '../../Shared/AccountTypesRadioListField';
import { ConnectedInputField } from '../../Shared/ConnectedInputField';
import { ClearableConnectedInputField } from '../../Shared/ClearableConnectedInputField';
import { EditModalRHF } from '../../Shared/EditModalRHF';

const { ESP, NAME, API_KEY, EDIT_API_KEY } = ESP_ACCOUNT_PAYLOAD_FIELDS;

export const MailgunEditModal = () => {
  const { espDefinitions = [] } = useSendingPlatformsQueryContext();
  const {
    formState: { defaultValues = {} },
  } = useFormContext();
  const { updateAccount } = useUpdateAccount();
  const esp = defaultValues[ESP];

  /** Only show MailGun ESP options that are returned from ESP Definitions query, and disable
   * any that are not applicable -- it is not possible to change ESP on an existing account.
   */
  const espOptions = getEspRadioOptionsForSendingPlatform(MAILGUN, espDefinitions, esp);

  return (
    <EditModalRHF onSubmit={updateAccount}>
      <ConnectedInputField name={NAME} labelText="Name" data-test="name-input" />
      {espOptions.length > 1 && (
        <AccountTypesRadioListField name={ESP} labelText="Account type" options={espOptions} />
      )}
      <ClearableConnectedInputField
        name={API_KEY}
        data-test="apiKey-input"
        labelText="API key"
        wasEditedFieldName={EDIT_API_KEY}
      />
    </EditModalRHF>
  );
};
